letterAdjust.scale = .9;
// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
var font = {
	"0": "M0 825q0 -438 70 -602q96 -223 389 -223t391 223q70 160 70 602q0 475 -84 637q-94 176 -377 176q-285 0 -377 -176q-82 -158 -82 -637zM319 821q0 393 19 475q16 111 121 111q98 0 121 -111q18 -88 18 -475q0 -389 -20 -477q-25 -113 -119 -113t-117 113 q-23 102 -23 477z",
	"1": "M0 1077v309q205 115 315 252h310v-1638h-351v1262q-123 -104 -274 -185z",
	"2": "M0 0v285l496 659q114 154 114 301q0 156 -121 156q-86 0 -118 -78q-23 -51 -23 -154h-321q-2 29 -2 58q0 201 122 309q117 102 320 102q469 0 469 -417q0 -279 -234 -549l-360 -422h608v-250h-950z",
	"3": "M0 455h322q0 -111 16 -152q27 -72 119 -70q158 2 157 248q0 162 -67 207q-57 39 -234 37v258q162 -10 213 29q59 45 60 202q0 190 -121 191q-80 0 -107 -57q-20 -39 -18 -127h-322q-2 236 111 335q92 82 344 82q227 0 331.5 -98.5t104.5 -327.5q0 -322 -215 -354v-2 q141 -29 199 -141q43 -86 43 -248q0 -467 -498 -467q-244 0 -341 104.5t-97 350.5z",
	"4": "M0 375h502v-375h321v375h129v252h-129v1011h-432l-391 -933v-330zM252 627l295 784h4l-21 -784h-278z",
	"5": "M0 401h326q0 -78 22 -114q31 -51 98 -51q92 0 121 77q23 55 23 244q0 150 -12 201q-29 123 -125 123q-119 0 -119 -183h-316v940h838v-249h-518l2 -408q74 109 233 109q211 0 287 -175q53 -115 53 -358q0 -289 -100 -416q-111 -141 -387 -141q-438 0 -426 401z",
	"6": "M0 684q0 -317 66 -463q100 -221 378 -221q477 0 478 545q0 510 -353 510q-78 0 -139 -29q-45 -20 -117 -82q0 315 21 389q25 86 125 86q121 0 112 -145h332q2 364 -418 364q-315 0 -411 -235q-74 -180 -74 -719zM322 516q0 176 20 236q27 82 113 82q100 0 129 -105 q14 -51 14 -186q0 -143 -14 -197q-29 -113 -133 -115q-66 0 -97.5 71t-31.5 214z",
	"7": "M0 1386v252h874v-311l-393 -1327h-368l448 1386h-561z",
	"8": "M0 432q0 -432 461 -432t461 432q0 170 -41 260q-53 121 -193 172v6q219 55 219 344q0 424 -446 424q-444 0 -445 -424q0 -145 39 -219q51 -94 181 -125v-6q-139 -49 -195 -172q-41 -92 -41 -260zM324 449q0 127 14 182q33 104 123 104q92 0 123 -104q16 -59 16 -182 q0 -217 -139 -218q-137 0 -137 218zM336 1200q0 207 125 207t125 -207q0 -217 -125 -217t-125 217z",
	"9": "M0 1071q0 -178 78 -295q90 -135 260 -135q156 0 262 104l-10 -399q-25 -113 -131 -113q-61 0 -94 52q-25 39 -25 112h-315q-6 -215 104 -311q102 -86 322 -86q309 0 411 258q59 152 60 555q0 440 -58 582q-94 244 -411 243q-453 0 -453 -567zM322 1137q0 123 16 178 q29 104 121 104q141 0 141 -276q0 -285 -143 -285q-90 0 -119 100q-16 54 -16 179z",
	"A": "M289 -410l311 2048h465l311 -2048h-315l-68 443h-321l-68 -443h-315zM721 346h225l-112 739z",
	"B": "M360 -410v2048h480q39 0 61.5 -1t66.5 -6t72.5 -14t68.5 -29.5t66.5 -49.5t56.5 -75t47 -102t29.5 -136t12.5 -176q0 -78 -24.5 -152t-59.5 -123t-68.5 -87t-58.5 -54l-25 -19q10 -6 25.5 -18t56.5 -54t72 -89t56.5 -121t25.5 -152q0 -96 -12.5 -176t-29.5 -136 t-47 -102.5t-56.5 -75t-66.5 -49t-68.5 -29.5t-72.5 -14.5t-66.5 -6.5t-61.5 -1h-480zM674 -98h166q70 0 119 82t49 196.5t-49.5 196.5t-118.5 82h-166v-557zM674 770h166q70 0 119 82t49 196.5t-49.5 196.5t-118.5 82h-166v-557z",
	"C": "M344 70v1089q0 199 140.5 339t339 140t340 -140t141.5 -339v-250h-314v250q0 70 -49 118t-118.5 48t-118 -48t-48.5 -118v-1089q0 -70 48.5 -118t118 -48t118.5 48t49 118v249h314v-249q0 -199 -141.5 -339.5t-340 -140.5t-339 140.5t-140.5 339.5z",
	"D": "M360 -410v2048h480q199 0 340 -140t141 -339v-1089q0 -199 -141.5 -339.5t-339.5 -140.5h-480zM674 -96h166q70 0 119 48t49 118v1089q0 70 -49.5 119t-118.5 49h-166v-1423z",
	"E": "M360 -410v2048h803v-311h-491v-557h336v-311h-336v-557h491v-312h-803z",
	"F": "M360 -410v2048h803v-311h-491v-557h336v-311h-336v-869h-312z",
	"G": "M344 70v1089q0 199 140.5 339t339 140t340 -140t141.5 -339v-250h-314v250q0 70 -49 118t-118.5 48t-119 -48t-49.5 -118v-1089q0 -70 49.5 -118t119 -48t118.5 48t49 118v233h-168v311h482v-1024h-158l-70 187q-4 -8 -11 -20.5t-34.5 -45.5t-63.5 -56.5t-96.5 -44 t-132.5 -20.5q-190 0 -292.5 135.5t-102.5 344.5z",
	"H": "M360 -410v2048h314v-868h334v868h313v-2048h-313v869h-334v-869h-314z",
	"I": "M360 -410v2048h312v-2048h-312z",
	"J": "M293 -98h168q70 0 119 49t49 119v1568h311v-1568q0 -199 -140.5 -339.5t-338.5 -140.5h-168v312z",
	"K": "M360 -410v2048h312v-649l336 649h313l-365 -704l365 -1344h-313l-256 947l-80 -152v-795h-312z",
	"L": "M362 -410v2048h312v-1736h491v-312h-803z",
	"M": "M360 -410v2048h420l221 -1212l220 1212h419v-2048h-313v1414l-254 -1414h-145l-256 1414v-1414h-312z",
	"N": "M360 -410v2048h314l334 -1060v1060h313v-2048h-313l-334 1061v-1061h-314z",
	"O": "M344 70v1089q0 199 140.5 339t339 140t340 -140t141.5 -339v-1089q0 -199 -141.5 -339.5t-340 -140.5t-339 140.5t-140.5 339.5zM657 70q0 -70 48.5 -118t118 -48t118.5 48t49 118v1089q0 70 -49 118t-118.5 48t-118 -48t-48.5 -118v-1089z",
	"P": "M360 -410v2048h480q39 0 61.5 -1t66.5 -6t72.5 -15t68.5 -30.5t66.5 -50.5t56.5 -77t47 -105.5t29.5 -141.5t12.5 -181t-12.5 -180t-29.5 -141.5t-47 -105.5t-56.5 -75.5t-66.5 -50t-68.5 -31t-72.5 -16.5t-66.5 -6h-61.5h-168v-834h-312zM672 735h168q168 0 168 296 t-168 296h-168v-592z",
	"Q": "M344 68v1089q0 199 141.5 340t340 141t340 -141t141.5 -340v-1089q-1 -113 -50 -211q66 -53 148 -54v-311q-209 0 -350 152q-106 -57 -230 -58q-199 0 -340 141.5t-141 340.5zM657 68q0 -70 49.5 -119t119 -49t118.5 49t49 119v1089q0 70 -49 119t-118.5 49t-119 -49 t-49.5 -119v-1089z",
	"R": "M360 -410v2048h480q39 0 61.5 -1t66.5 -6t72.5 -15t68.5 -30.5t66.5 -50.5t56.5 -77t47 -105.5t29.5 -141.5t12.5 -181q0 -440 -221 -559l221 -881h-322l-211 834h-116v-834h-312zM674 735h166q168 0 168 295t-168 295h-166v-590z",
	"S": "M344 70v110h313v-110q0 -70 48.5 -118t118 -48t118.5 48t49 118q0 82 -27.5 153.5t-72.5 124.5t-103.5 108.5t-120 103.5t-118.5 110.5t-103.5 128t-74 159t-27.5 201.5q0 199 140.5 339t339 140t340 -140t141.5 -339v-110h-314v110q0 70 -49 118t-118.5 48t-118 -48 t-48.5 -118q0 -74 21.5 -136t59.5 -109.5t86 -91.5t102.5 -86t107.5 -87t102.5 -101t86.5 -123t59.5 -157t22.5 -198q0 -199 -140.5 -339.5t-340 -140.5t-340 140.5t-140.5 339.5z",
	"T": "M330 1325v313h960v-313h-323v-1735h-314v1735h-323z",
	"U": "M356 70v1568h312v-1568q0 -70 49 -118t118.5 -48t119 48t49.5 118v1568h313v-1568q0 -199 -141.5 -339.5t-340 -140.5t-339 140.5t-140.5 339.5z",
	"V": "M315 1638h314l166 -1099l168 1099h313l-313 -2048h-334z",
	"W": "M315 1638h314l166 -1179l168 1179h241l168 -1179l168 1179h311l-311 -2048h-336l-121 1024l-120 -1024h-334z",
	"X": "M338 -410l324 1024l-324 1024h313l166 -530l168 530h313l-323 -1024l323 -1024h-313l-168 531l-166 -531h-313z",
	"Y": "M297 1638h326l186 -606l186 606h326l-356 -1163v-885h-312v885z",
	"Z": "M358 -98l648 1423h-648v313h961v-313l-649 -1423h649v-312h-961v312z"
};

var font_size = 21,
	panel_Hor_Adjustment = -.5,
	font_Top_Adjustment = -6,
	tracking = 1,
	small_Caps_Adjustment = {
		vertical: 0,
		horizontal: 0,
		scale_width: 0,
		scale_height: 0,
	},
	// brown #8d7966;
	// bashe #f1e5c6;
	// red "#b81237;
	colors = {
		characters: {
			home: [
				"#FFFFFF",
			],
			away: []
		},
		numbers: {
			home: [
				"#FFFFFF",
				"#EFE2CD",
				"#F2B113",
			],
			away: []
		}
	},
	outlines = {
		characters: {
			width: 0 // also acts as tracking if no outlines exsist
		},
		numbers: {
			width: 4
		}
	},
	special_Character_Adjustments = {
		period: {
			vertical: 3, // this moves it up from the bottom
			horizontal: -2.5,
			scale_width: 15.5,
			scale_height: 15.5,
		},
		hyphen: {
			vertical: 0,
			horizontal: -5.5,
			scale_width: 0,
			scale_height: -12,
		},
		apostrophe: {
			vertical: -5.75,
			horizontal: -2.5,
			scale_width: 0,
			scale_height: 0,
		}
	},
	number_Adjustments = {
		top: 19,
		left: -6,
		width: 90,
		height: 68,
		middle_Space: 5,
	};